import { useFormattedDate } from "@jugl-web/utils/hooks/useFormattedDate";
import { FC } from "react";
import { getTicketHistoryIcon } from "./utils/getTicketHistoryIcon";
import { ParsedTicketActivity } from "./types";

export interface TicketHistoryItemProps {
  activity: ParsedTicketActivity;
  isLast?: boolean;
}

export const TicketHistoryItem: FC<TicketHistoryItemProps> = ({
  activity,
  isLast = false,
}) => {
  const { localeAwareFormat } = useFormattedDate();

  return (
    <div className="relative flex gap-4 pb-10">
      {!isLast && (
        <span
          aria-hidden
          className="absolute top-[18px] bottom-0 left-[8.5px] w-px bg-[#E0E0E0]"
        />
      )}
      <div className="relative z-1 flex h-[18px] w-[18px] shrink-0 items-center justify-center bg-white">
        {getTicketHistoryIcon(activity.icon)}
      </div>
      <div className="flex min-w-0 flex-col gap-1 font-secondary">
        <div className="jugl__break-word text-[13px] leading-[140%] text-dark">
          {activity.message}
        </div>
        <time className="text-xs text-grey-900">
          {localeAwareFormat(activity.date, "h:mm a, MMM d, yyyy")}
        </time>
      </div>
    </div>
  );
};
